import { FastForward } from "@mui/icons-material";
import Duration from "../../images/internship/duration.png";
import Members from "../../images/internship/members.png";
import Slots from "../../images/internship/slots.png";
import Stipend from "../../images/internship/stipend.png";
import toList, { toHTML } from "../utils/ComponentUtil";
import './InternshipTemplate.scss';

function InternshipTemplate({ internship }) {
    return (
        <div className="internship-details">
            <div className="header">
                <div className="name">Brand Kit And Logo Design Work</div>
                <div className="posted-on">Posted On: 01 June 2022</div>
            </div>
            <div className="perks">
                <div className="details">
                    <div className="detail">
                        <img className="img" src={Stipend} alt="img" />
                        <div className="name">Stipend:</div>
                        <div className="unit">{internship?.stipend}</div>
                    </div>
                    <div className="detail">
                        <img className="img" src={Duration} alt="img" />
                        <div className="name">Duration:</div>
                        <div className="unit">{internship?.duration}</div>
                    </div>
                    <div className="detail">
                        <img className="img" src={Members} alt="img" />
                        <div className="name">Members Working:</div>
                        <div className="unit">{internship?.members}</div>
                    </div>
                    <div className="detail">
                        <img className="img" src={Slots} alt="img" />
                        <div className="name">Slots Remaining:</div>
                        <div className="unit">{internship?.slotsRemaining}</div>
                    </div>
                </div>
                <div className="skills-needed">
                    <div className="title">Skills Needed:</div>
                    <div className="skills">
                        {toList(internship?.skillsNeeded, undefined, (item, i) =>
                            <div className="skill" key={i}>
                                <div className="name">{item}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="about">
                <div className="title">About This Talent</div>
                <div className="content">{internship?.about}</div>
            </div>
            <div className="advantages">
                <div className="title">What are some advantages of hiring me?</div>
                {
                    toList(internship?.advantages, undefined, (item, i) =>
                        <div className="text" key={i}>{toHTML(item)}</div>)
                }
            </div>
            <div className="faqs">
                <div className="title">
                    Some Common FAQs Related to Graphic Design Work
                </div>
                {
                    toList(internship?.faqs, undefined, (item, i) =>
                        <div className="faq" key={i}>
                            <div className="question"><FastForward/>{item?.question}</div>
                            <div className="answer">{item?.answer}</div>
                        </div>
                    )
                }
            </div>
            <div className="apply">
                <div className="text">Apply</div>
            </div>
        </div>
    );
}

export default InternshipTemplate;
